import {
  ApolloClient,
  createHttpLink,
  InMemoryCache,
  NormalizedCacheObject,
} from "@apollo/client/core";

export const createApolloClient = (
  apiUrl: string
): ApolloClient<NormalizedCacheObject> => {
  const httpLink = createHttpLink({
    uri: apiUrl,
  });

  const cache = new InMemoryCache();

  return new ApolloClient({
    link: httpLink,
    cache,
  });
};
